
import hash from './hasher.js';

const defaultState = Object.freeze({
        tree: [{ name:'empty' }],
        intermediateHash: [],
        leafInputs: [],
        stagedFiles: [],
        stagedText: "",
        treeKey: 0,
        activeInfoBox: null,
    });


export default function merkelReducer(state = defaultState, action = {type:'NO-OP'}) {
    switch( action.type ) {
        case 'MERKLE-STAGE-FILES':
            return stageFiles(state, action);
        case 'MERKLE-STAGE-TEXT':
            return stageText(state, action);
        // MERKLE-ADD-FILES triggers epic
        //case 'MERKLE-ADD-FILES':
        //    return addFiles(state, action);
        case 'MERKLE-UPDATE-FILES':
            return updateFiles(state, action);
        case 'MERKLE-ADD-TEXT':
            return addText(state, action);
        case 'MERKLE-VIEW-INPUT':
            return viewInput(state, action);
        case 'MERKLE-REMOVE-INPUT':
            return removeInput(state, action);
        case 'MERKLE-UPDATE-TREE':
            return updateTree(state, action);
        default:
            return state;
    }
};



function stageFiles(state, action) {
    return {
        ...state,
        stagedFiles: action.fileList,
    };
}

function stageText(state, action) {
    return {
        ...state,
        stagedText: action.text,
    };
}

function updateFiles(state, action) {
    const leaves = [
            ...state.leafInputs,
            ...(action.files || []).map(function convert(file) {
                return {
                    data: file.filename,
                    contents: file.contents,
                    hash: hash(file.contents),
                };
            }),
        ];
    return {
        ...state,
        //stagedFiles: [], // file input button does not get reset
        leafInputs: leaves,
        tree: [{name:''}],
    };
}

function addText(state, action) {
    const toAdd = action.text || state.stagedText;
    if( !toAdd ) {
        console.log('no text to add');
        return state;
    }
    const leaves = [
            ...state.leafInputs,
            {
                data: toAdd,
                hash: hash(toAdd),
            },
        ];
    return {
        ...state,
        leafInputs: leaves,
        stagedText: "",
        tree: [{name:''}],
    };
}

function viewInput(state, action) {
    console.log('VIEW INPUT', action, state.tree);
    const path = [];
    let pointer = action.node;
    while( pointer ) {
        path.push(pointer);
        pointer = pointer.parent;
    }
    return {
        ...state,
        activeInfoBox: {
            node: action.node,
            path,
        },
    };
}

function removeInput(state, action) {
    
    return state;
}


function updateTree(state, action) {
    if( !action || !action.tree ) {
        return state;
    }
    return {
        ...state,
        tree: action.tree,
        treeKey: (state.treeKey || 0) + 1,
    };
}






// WEBPACK FOOTER //
// ./src/reducers/merkle-reducer.js